import moment from 'moment';
import numeral from 'numeral';
import React, { Component } from 'react';
import './IRAContribution.scss';
import Button from '../../../Shared/Button/Button';
import { AVAILABLE_CONTRIBUTION_TIP_TEXT } from '../../../../settings/settings';
import { formatUnixDate } from '../../../../utils/dates/date-utility';
import { isRecurringBuy } from '../../../../utils/transactions-util';
numeral.defaultFormat('$0,0.00');

export class IRAContribution extends Component {
  calcFunds = (userFunds) => {
    return userFunds !== null && userFunds.funds !== null
      ? userFunds.funds[0]
      : undefined;
  };

  render() {
    const {
      handleClose,
      IRALimit,
      IRALimitData,
      showSelectedYearOnlySmallVP,
      userFunds,
      fund,
    } = this.props;
    const funds = this.calcFunds(userFunds);
    const tradeDate = funds
      ? moment.utc(funds.displayTradeDate).format('MM/DD/YYYY')
      : '';
    const data = fund || IRALimitData || (IRALimit ? IRALimit.data : {});
    const currentYear = funds
      ? formatUnixDate(funds.displayTradeDate, 'YYYY')
      : '';
    const currentMaxContributions = numeral(
      data.currentYearMaximumLimit
    ).format('$0,0.00');
    const currentIRAContribution = numeral(
      data.currentYearContributionsSoFar
    ).format('$0,0.00');
    const currentAutomaticContribution = numeral(
      data.currentYearRemainingAutomaticPurchases
    ).format('$0,0.00');
    const currentRemainingContribution = numeral(
      Math.round(
        ((data.currentYearMaximumLimit -
          data.currentYearContributionsSoFar -
          data.currentYearRemainingAutomaticPurchases) *
          100) /
          100
      )
    ).format('$0,0.00');

    let priorYear = '';
    let priorMaxContributions = '';
    let priorIRAContribution = '';
    let priorAutomaticContribution = '';
    let priorRemainingContribution = '';

    const priorYearClassName = showSelectedYearOnlySmallVP
      ? isRecurringBuy()
        ? 'hidden'
        : 'hidden-xs'
      : '';
    const currentYearClassName = showSelectedYearOnlySmallVP
      ? ''
      : isRecurringBuy()
      ? ''
      : 'hidden-xs';

    if (data.withinIRAPriorYearContributionPeriod) {
      priorYear = currentYear - 1;
      priorMaxContributions = numeral(data.priorYearMaximumLimit).format(
        '$0,0.00'
      );
      priorIRAContribution = numeral(data.priorYearContributionsSoFar).format(
        '$0,0.00'
      );
      priorAutomaticContribution = numeral(
        data.priorYearRemainingAutomaticPurchases
      ).format('$0,0.00');
      priorRemainingContribution = numeral(
        Math.round(
          ((data.priorYearMaximumLimit -
            data.priorYearContributionsSoFar -
            data.priorYearRemainingAutomaticPurchases) *
            100) /
            100
        )
      ).format('$0,0.00');
    }

    return (
      <div className="ira-contribution-container">
        <h1 className="ira-contribution-header">
          {data.minorIRAContribution
            ? `${data.ownerName && data.ownerName.split(' ', 1)}'s`
            : 'Your'}{' '}
          IRA Contribution Information
        </h1>
        <table className="ira-contribution-table">
          <thead>
            <tr>
              <th />
              <th className={priorYearClassName}>{priorYear}</th>
              <th className={currentYearClassName}> {currentYear} </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Annual IRA contribution limit</td>
              <td className={priorYearClassName}>{priorMaxContributions}</td>
              <td className={currentYearClassName}>
                {currentMaxContributions}
              </td>
            </tr>
            <tr>
              <td
                className={isRecurringBuy() ? 'ira-contribution-oneLine' : ''}
              >
                <p>Your IRA contributions</p> (as of {tradeDate})*
              </td>
              <td className={priorYearClassName}>{priorIRAContribution}</td>
              <td className={currentYearClassName}>{currentIRAContribution}</td>
            </tr>
            <tr>
              <td>Scheduled automatic IRA contributions</td>
              <td className={priorYearClassName}>
                {priorAutomaticContribution}
              </td>
              <td className={currentYearClassName}>
                {currentAutomaticContribution}
              </td>
            </tr>
            <tr>
              <td>Remaining Annual IRA contribution limit</td>
              <td className={priorYearClassName}>
                {priorRemainingContribution}
              </td>
              <td className={currentYearClassName}>
                {currentRemainingContribution}
              </td>
            </tr>
          </tbody>
        </table>
        <div className="ira-contribution-footer">
          <div className="ira-contribution-footer-button">
            <Button buttonType="primary" onClick={() => handleClose(false)}>
              Close
            </Button>
          </div>
          <div className="ira-contribution-footer-text">
            <p>{AVAILABLE_CONTRIBUTION_TIP_TEXT}</p>
            <p>
              You cannot contribute more than your earned income for the year.
            </p>
            <p>*Includes pending transactions.</p>
          </div>
        </div>
      </div>
    );
  }
}

export default IRAContribution;
